import { useRef } from 'react'
import { com } from '@eidu/form'
import usePermittedActions from '../../io/usePermittedActions'
import GlobalAction = com.eidu.sharedlib.entity.permission.GlobalAction
import PermittedGlobalAction = com.eidu.sharedlib.entity.permission.PermittedGlobalAction

const useHasGlobalPermissions = (...actions: GlobalAction[]) => {
  const requested = useRef(actions.map((action) => new PermittedGlobalAction(action)))
  const [permissions, error, loading] = usePermittedActions(requested.current)

  const hasPermission = (action: GlobalAction) =>
    permissions?.some((p) => p.equals(new PermittedGlobalAction(action))) ?? false

  return { hasPermission, error, loading }
}

export default useHasGlobalPermissions
